import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-168514b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"inline-block"} }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { computed, onMounted, ref } from 'vue'
import { deliveryStore } from '@/stores/delivery'
import TextEditor from '@/components/TextEditor.vue'
import Uploader from '@/components/Uploader.vue'
import Filelist from '@/components/Filelist.vue'
import DeliveryAnswerIssues from '@/components/delivery/DeliveryAnswerIssues.vue'
import axios from 'axios'
import { Modal, notification } from 'ant-design-vue'
import { CameraFilled, WarningFilled } from '@ant-design/icons-vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryQuestionCard',
  props: {
    question: null,
    room: null,
    lastItem: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { question:{ id:number, name:string, show_ntb:boolean, answer: { id:number, answer:string|null, note:string|null, media:{ id:number, url:string }[], issues:{ id:number, description:string, status:number }[] } }, room:{ id:number, level:number }, lastItem: boolean };

const route = useRoute()


const screenWidth = computed(() => window.innerWidth)
const answer = ref<{ id?:number, answer:string|null, note:string|null, media:{ id:number, url:string }[], issues:{ id:number, description:string, status:number }[] }>({ answer: null, note: null, media: [], issues: [] })

onMounted(() => {
  setAnswer()
})

function setAnswer () : void {
  answer.value.id = props.question.answer.id
  answer.value.answer = props.question.answer.answer
  answer.value.note = props.question.answer.note
  answer.value.media = props.question.answer.media
  answer.value.issues = props.question.answer.issues
}

function updateAnswer (id:number, answer:{ answer:string|null, note:string|null, media:[] }) : void {
  if (answer.answer === 'no' && answer.media.length) {
    Modal.warning({
      title: 'Let op! Afbeeldingen moeten per gebrek worden toegevoegd.',
      content: 'Eerder toegevoegde afbeeldingen bij deze vraag zullen NIET worden opgeslagen.',
      okText: 'Oke, sluiten.'
    })
  }

  deliveryStore().updateAnswer(id, answer)
}

function answerNoteChanged (val:string) : void {
  answer.value.note = val
  deliveryStore().updateAnswer(props.question.answer.id, answer.value)
}

function addAnswerMedia (file:File) : void {
  const formData = new FormData()
  formData.append('files', file)

  axios.post(process.env.VUE_APP_API_URL + '/deliveries/answers/' + props.question.answer.id + '/media/add', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    answer.value.media.push(r.data.data)
  })
}

function updateAnswerMedia (data:{ file:File, mediaId:number }) : void {
  const formData = new FormData()
  formData.append('files', data.file)
  formData.append('mediaId', data.mediaId.toString())

  axios.post(process.env.VUE_APP_API_URL + '/deliveries/answers/' + props.question.answer.id + '/media/update', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    answer.value.media.forEach((m:{ id:number }, index) => {
      if (m.id === data.mediaId) {
        answer.value.media[index] = r.data.data
        notification.success({
          message: 'Afbeelding bijgewerkt.',
          description: 'De afbeelding is succesvol bijgewerkt.',
          duration: 5
        })
      }
    })
  })
}

function deleteFile (file:{ id:number }) : void {
  axios.post(process.env.VUE_APP_API_URL + '/deliveries/answers/' + props.question.answer.id + '/media/delete', { mediaId: file.id }).then(() => {
    answer.value.media.forEach((m:{ id:number }, index) => {
      if (m.id === file.id) {
        answer.value.media.splice(index, 1)
        notification.success({
          message: 'Bestand verwijderd.',
          description: 'Het bestand is succesvol verwijderd.',
          duration: 5
        })
      }
    })
  })
}

function issueAdded (issue:{ id:number, description:string, status:number }) : void {
  answer.value.issues.push(issue)
  deliveryStore().getDelivery(route.params.deliveryId)
}

function issueUpdated (issue:{ id:number, description:string, status:number }) : void {
  answer.value.issues.forEach((i:{ id:number, description:string, status:number }, index) => {
    if (i.id === issue.id) {
      answer.value.issues[index] = issue
    }
  })
  deliveryStore().getDelivery(route.params.deliveryId)
}

function issueDeleted (id:number) : void {
  answer.value.issues.forEach((i:{ id:number, description:string, status:number }, index) => {
    if (i.id === id) {
      answer.value.issues.splice(index, 1)
    }
  })
  deliveryStore().getDelivery(route.params.deliveryId)
}

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_1, "- " + _toDisplayString(__props.question.name), 1),
            (__props.question.required)
              ? (_openBlock(), _createBlock(_component_a_tag, {
                  key: 0,
                  color: "#f38929",
                  style: _normalizeStyle({ float: _unref(screenWidth) < 768 ? 'left' : 'right' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Verplicht")
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse, { bordered: false }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  header: "Controlepunten",
                  style: {"border-bottom":"5px solid white"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: __props.question.description
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: {span: 24},
          sm: {span: 24},
          md: {span: 24},
          lg: {span: __props.question.show_ntb ? 8 : 6}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_group, {
                      value: answer.value.answer,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((answer.value.answer) = $event)),
                      "button-style": "solid",
                      disabled: _unref(deliveryStore)().deliveryClosed,
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (updateAnswer(__props.question.answer.id, answer.value)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_button, {
                          value: "yes",
                          class: "good"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Goed")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio_button, {
                          value: "no",
                          class: "wrong"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Fout")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio_button, { value: "nvt" }, {
                          default: _withCtx(() => [
                            _createTextVNode("N.V.T.")
                          ]),
                          _: 1
                        }),
                        (__props.question.show_ntb)
                          ? (_openBlock(), _createBlock(_component_a_radio_button, {
                              key: 0,
                              value: "ntb"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("N.T.B.")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["value", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["lg"]),
        _createVNode(_component_a_col, {
          xs: {span: 24},
          sm: {span: 24},
          md: {span: 24},
          lg: {span: __props.question.show_ntb ? 16 : 18}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse, { bordered: false }, {
              default: _withCtx(() => [
                (['yes'].includes(answer.value.answer))
                  ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                      key: 0,
                      header: "Opmerkingen en foto's",
                      style: {"border-bottom":"5px solid white"}
                    }, {
                      extra: _withCtx(() => [
                        _createVNode(_component_a_tag, { color: "#666" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CameraFilled)),
                            _createTextVNode(" " + _toDisplayString(answer.value.media.length), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                (!_unref(deliveryStore)().deliveryClosed)
                                  ? (_openBlock(), _createBlock(TextEditor, {
                                      key: 0,
                                      content: answer.value.note,
                                      returnOn: "blur",
                                      onContentChange: _cache[2] || (_cache[2] = ($event: any) => (answerNoteChanged($event)))
                                    }, null, 8, ["content"]))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      innerHTML: answer.value.note
                                    }, null, 8, _hoisted_3))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                (!_unref(deliveryStore)().deliveryClosed)
                                  ? (_openBlock(), _createBlock(Uploader, {
                                      key: 0,
                                      "current-count": answer.value.media.length,
                                      "upload-button": "",
                                      onNewFileUploaded: addAnswerMedia
                                    }, null, 8, ["current-count"]))
                                  : _createCommentVNode("", true),
                                (answer.value.media.length)
                                  ? (_openBlock(), _createBlock(Filelist, {
                                      key: 1,
                                      media: answer.value.media,
                                      onImageEdited: _cache[3] || (_cache[3] = ($event: any) => (updateAnswerMedia($event))),
                                      onDeleteFile: deleteFile,
                                      "can-edit": !_unref(deliveryStore)().deliveryClosed,
                                      "can-comment": !_unref(deliveryStore)().deliveryClosed,
                                      "can-delete": !_unref(deliveryStore)().deliveryClosed
                                    }, null, 8, ["media", "can-edit", "can-comment", "can-delete"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (answer.value.answer === 'no')
                  ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                      key: 1,
                      header: "Gebrek(en)",
                      style: {"border-bottom-color":"white"}
                    }, {
                      extra: _withCtx(() => [
                        _createVNode(_component_a_tag, { color: "#666" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(WarningFilled)),
                            _createTextVNode(" " + _toDisplayString(__props.question.answer.issues.length), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(DeliveryAnswerIssues, {
                          answer: answer.value,
                          room: __props.room,
                          onIssueAdded: _cache[4] || (_cache[4] = ($event: any) => (issueAdded($event))),
                          onIssueUpdated: _cache[5] || (_cache[5] = ($event: any) => (issueUpdated($event))),
                          onIssueDeleted: _cache[6] || (_cache[6] = ($event: any) => (issueDeleted($event)))
                        }, null, 8, ["answer", "room"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["lg"])
      ]),
      _: 1
    }),
    (!__props.lastItem)
      ? (_openBlock(), _createBlock(_component_a_divider, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})